import {
  faChevronDoubleRight,
  faLoader,
  faPlus,
  faTrash,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useAppContext } from "../../../AppProvider";
import { useIndexOrderDetailsContext } from "../providers/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHandlerOrderContext } from "../../Orders/providers/Handler";

export const useListProps = () => {
  const { dictionary, accessTokenPayload } = useAppContext();

  const context = useIndexOrderDetailsContext();
  const handlerOrderContext = useHandlerOrderContext();

  return {
    path: `/logistic-service/order-details`,
    banner: {
      enabled: false,
    },
    pagination: { enabled: false },
    sorting: [
      {
        orderBy: "desc",
        column: "article.uniqueBarcodeItem",
        isDefault: true,
      },
    ],
    defaultPagination: {
      page: 0,
      size: 200,
    },
    filters: {
      name: "",
      preserve: false,
      list:
        context?.action === "process"
          ? [
              {
                fieldName: "article.shippingRequired",
                value: [
                  {
                    value: "true",
                    isBool: true,
                  },
                ],
                type: "select",
                hidden: true,
              },
            ]
          : [],
    },
    title: <h3 className="m-0">{dictionary.products.products}</h3>,
    create: {
      enabled: context?.action !== "details" && context?.action !== "process",
      action: () => {
        context.setModal({
          open: true,
          title: `${
            dictionary.actions.add
          } ${dictionary.products.product.toLowerCase()}`,
          action: "create",
        });
      },
      title: `${
        dictionary.actions.add
      } ${dictionary.products.product.toLowerCase()}`,
      icon: faPlus,
    },
    selectRowsEnabled: {
      enabled: context?.action !== "details" && context?.action !== "process",
    },
    actionBar: {
      enabled: context?.action !== "details" && context?.action !== "process",
      fixed: context?.action !== "details" && context?.action !== "process",
    },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModal({
            open: true,
            title: dictionary.actions.confirm_deletion,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),

        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
      },
    ],
    actions: [
      {
        onClick: () => context?.nextDetail(true),
        label: `${
          dictionary.actions.process} ${dictionary.products.products}`,
        icon: context?.orderDetailLoader ? (
          <FontAwesomeIcon spin icon={faLoader} />
        ) : (
          <FontAwesomeIcon icon={faChevronDoubleRight} />
        ),
        className: "button-1 button-1-transparent",
        hidden:
          context?.action === "process" ||
          handlerOrderContext?.order?.lastStatus !== "PROCESSING" ||
          accessTokenPayload.owner !== "7f8625b9-973b-4c66-80af-346b49cde2e7",
        loading: context?.orderDetailLoader,
      },
    ],
  };
};
